import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

if (process.env.NODE_ENV !== 'production') {
  import('react-axe').then((reactAxe) => {
    const ReactDOM = require('react-dom'); // Only needed for React 17 and below
    const axe = require('axe-core'); // Ensure axe-core is available

    reactAxe.default(React, ReactDOM, 1000); // 1000 ms debounce time
    console.log('React-axe is initialized');
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App /> {/* No need to wrap in Router here */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
